import React from 'react';
import emailjs from 'emailjs-com';

import './css/Contact.css';

export default function Contact() {
    function sendEmail(e) {
        e.preventDefault();

        if (!e.target.first_name.value ||
          !e.target.last_name.value ||
          !e.target.from_email.value) {
          alert("Please enter your first and last name, along with a valid email address");
        } else {
          emailjs.sendForm('gillassocphoto', 'contact_template', e.target, 'user_kA97brIZjO1nouWCzOgxd')
              .then((result) => {
                  alert("Thank you for your request. We'll be in contact with you soon.");
                  console.log(result.text);
              }, (error) => {
                  alert("There was a problem submitting your request.");
                  console.log(error.text);
              });
        }
    }

    return (
        <div className="contact">
          <h2>Contact</h2>

          <form className="contact-form" onSubmit={sendEmail}>
            <table>
            <tbody>
              <tr>
                <td>First Name: <span className="required">*</span></td>
                <td><input type="text" name="first_name" /></td>
              </tr>
              <tr>
                <td>Last Name: <span className="required">*</span></td>
                <td><input type="text" name="last_name" /></td>
              </tr>
              <tr>
                <td>Email address: <span className="required">*</span></td>
                <td><input type="text" name="from_email" /></td>
              </tr>
              <tr>
                <td>Home Phone: </td>
                <td><input type="text" name="home_phone" /></td>
              </tr>
              <tr>
                <td>Work Phone: </td>
                <td><input type="text" name="work_phone" /></td>
              </tr>

              <tr><td colSpan={2}>&nbsp;</td></tr>

              <tr>
                <td colSpan={2}><b>What are you interested in? Check all that apply.</b></td>
              </tr>

              <tr>
                <td><input name="family_portraits" type="checkbox" value="Family Portraits"/> Family Portraits</td>
                <td><input name="child_portraits" type="checkbox" value="Child Portraits"/> Child Portraits</td>
              </tr>
              <tr>
                <td><input name="wedding_portraits" type="checkbox" value="Wedding Portraits"/> Wedding Portraits</td>
                <td><input name="pet_portraits" type="checkbox" value="Pet Portraits"/> Pet Portraits</td>
              </tr>
              <tr>
                <td><input name="special_occasions" type="checkbox" value="Special Occasions"/> Special Occasions</td>
                <td><input name="commercial_assignment" type="checkbox" value="Commercial Assignment"/> Commercial Assignment</td>
              </tr>

              <tr><td colSpan={2}>&nbsp;</td></tr>

              <tr>
                <td colSpan={2}>Message</td>
              </tr>
              <tr>
                <td colSpan={2}><textarea name="message" /></td>
              </tr>
              <tr>
                <td><input type="submit" value="Send" /></td>
              </tr>
            </tbody>
            </table>
          </form>
        </div>
    );
}
